import TitleHeader from '../../atoms/TitleHeader/TitleHeader'
import Constants from '../../../app/utils/constants'
import colors from '../../theme/color'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

const { portfolioProjectCards } = Constants

const PortfolioProjectSection = () => {
  const navigate = useNavigate()

  const getProjectPath = (projectName: string) => {
    switch (projectName.toLowerCase()) {
      case 'gostor':
        return '/portfolio/gostor'
      case 'rabbitx':
        return '/portfolio/rabbitx'
      case 'cryptonary':
        return '/portfolio/cryptonary'
      case 'arb ventures':
        return '/portfolio/arbventure'
      case 'tatvacare':
      case 'tatva care':
        return '/portfolio/tatvacare'
      case 'ddx':
        return '/portfolio/ddx'
      case 'medilearn':
        return '/portfolio/medilearn'
      default:
        return undefined
    }
  }

  return (
    <section className="mx-auto w-full max-w-[90%] pt-15 md:py-5">
      <TitleHeader
        badgeText="PROJECTS"
        titleLines={['Our Projects on Display']}
        wrapperClassName="mx-auto mb-10 flex max-w-5xl flex-col items-center text-center md:mb-14"
        titleClassName="text-3xl md:text-5xl lg:text-6xl font-rajdhani font-semibold"
        badgeClassName="text-2xl md:text-3xl px-10 md:px-12 py-2 md:py-1"
      />

      {/* GRID */}
      <div className="grid md:grid-cols-2 gap-12 md:gap-8">
        {portfolioProjectCards.map((card, index) => {
          const glowColor =
          index === 0
            ? colors.purple
            : index === 1
            ? '#EE364E'
            : index === 2
            ? '#3C8501'
            : index === 3
            ? '#429561'
            : index === 4
            ? '#619542'
            : index === 5
            ? '#5E0F9B'
            : '#9BB069'

          return (
            <motion.article
            key={card.name}
            className="group relative flex h-full flex-col cursor-pointer"
              role="button"
              tabIndex={0}
              onClick={() => {
                const path = getProjectPath(card.name)
                if (path) navigate(path)
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  const path = getProjectPath(card.name)
                  if (path) navigate(path)
                }
              }}
              initial={{ opacity: 0, scale: 0.7, y: 40 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
                ease: 'easeIn',
              }}
              whileHover={{ scale: 1.03 }}
            >
              {/* 🔥 GLOW WRAPPER */}
              <div className="relative rounded-3xl">

                {/* ✨ Glow Effect */}
                <div
                  className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-50 transition-opacity duration-500"
                  style={{
                    boxShadow: `0 0 8px 5px  ${glowColor}`,
                  }}
                />

                {/* CARD */}
                <div className="relative w-full aspect-20/10 overflow-hidden rounded-2xl border border-white/10 md:rounded-3xl bg-[#140c2f]">
                  <img
                    src={card.image}
                    alt={`${card.name} featured project`}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />

                  <div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/20 to-transparent" />
{/* 
                  {!card.hideHeroText && (
                    <div className="absolute left-[4%] top-[4%] z-10 flex w-[90%] flex-col">
                      <h1 className="font-gilroy-bold text-2xl text-white md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl">
                        {card.name}
                      </h1>

                      <h3 className="max-w-[50%] font-gilroy text-sm text-white md:text-sm lg:text-lg xl:text-xl 2xl:text-2xl">
                        {card.tagline}
                      </h3>
                    </div>
                  )} */}
                </div>
              </div>

              {/* CONTENT */}
              <div className="relative z-20 mt-3 flex flex-1 items-stretch justify-start md:mt-1">
              <div className="flex h-full w-full flex-col overflow-hidden rounded-2xl bg-[#140c2f] md:rounded-3xl">
                  <div className="flex items-center justify-between gap-4 px-4 pt-4 md:px-4 md:pt-3">
                    <h3 className="font-rajdhani xl:ml-5 text-xl font-semibold text-white md:text-lg lg:text-xl xl:text-3xl 2xl:text-4xl">
                      {card.name}
                    </h3>

                    <span
                      className="shrink-0 rounded-full px-[2%] py-[1%] font-gilroy-medium text-sm tracking-wide text-white md:text-xs lg:text-xs xl:text-sm 2xl:text-2xl"
                      style={{ backgroundColor: glowColor }}
                    >
                      {card.tag}
                    </span>
                  </div>

                  <p className="max-w-[90%] mt-2 flex-1 px-4 pb-3 font-gilroy-medium text-sm leading-tight text-white/75 md:px-4 md:pb-4 md:text-xs lg:text-sm xl:ml-5 xl:text-base 2xl:text-2xl 2xl:leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            </motion.article>
          )
        })}
      </div>
    </section>
  )
}

export default PortfolioProjectSection